export default __webpack_public_path__ + "media/src/assets/images/people-ea1408b064ab13c9358f2e78473239f1.png";